import { useMutation } from '@tanstack/react-query';

import {
  getUserTokenWithCode,
  GetUserTokenWithCodePayload
} from '../api/getUserTokenWithCode';

export const useRegister = () => {
  return useMutation({
    mutationFn: async (payload: GetUserTokenWithCodePayload) => {
      return await getUserTokenWithCode(payload);
    }
  });
};
